import qs from 'qs';

const getQuery = (search: string) => qs.parse(search.replace(/^\?/, ''));

export default getQuery;